import { UploadFormValues } from "../../../../components/UploadBoard/UploadForm";
import useTrackGoogleEvent, {
  UPLOAD_GERBERS_EVENT,
} from "../../../observability/googleTagManager";
import settings from "../../../../constants/settings";
import useFetchAndTrace, {
  FetchAndTraceErrorHandler,
} from "../../fetchWithTrace";
import { GerberFileUploadLinks } from "../../../../components/UploadBoard";
import { useUploadFileToS3 } from "../../uploadToS3";
import { useCallback, useState } from "react";
import { updateGerberLayerMapping } from "../../../../reducers/uploadedBoard";
import useSendBoardEvent, {
  BoardTransitionEvent,
  MachineGroup,
} from "./state-machine/sendBoardEvent";
import { useAppDispatch } from "../../store";

export default function useReuploadGerbers(boardId: string) {
  const fetchAndTrace = useFetchAndTrace();
  const [loading, setLoading] = useState(false);
  const [errored, setErrored] = useState(false);
  const errorHandler: FetchAndTraceErrorHandler = useCallback(() => {
    setLoading(false);
    setErrored(true);
  }, []);
  const uploadFileToS3 = useUploadFileToS3(errorHandler);
  const trackGoogleEvent = useTrackGoogleEvent();
  const { sendBoardEvent } = useSendBoardEvent();
  const dispatch = useAppDispatch();

  const onSubmit = (values: UploadFormValues) => {
    setLoading(true);
    const reuploadGerbers = async (fileUploadLinks: GerberFileUploadLinks) => {
      return uploadFileToS3(fileUploadLinks.zip_file, values.files[0]![0]!);
    };

    const uploadHandler = async (uploadResponse: Response) => {
      if (uploadResponse.ok) {
        const fileUploadLinks =
          (await uploadResponse.json()) as GerberFileUploadLinks;
        await reuploadGerbers(fileUploadLinks);

        await sendBoardEvent(boardId, {
          machine_group: MachineGroup.BOARD,
          model_id: boardId,
          event: BoardTransitionEvent.GERBERS_UPLOADED_EVENT,
          update: {
            s3_key: fileUploadLinks.zip_file.s3_key,
            gerber_file_layer_mapping: values.gerberFileLayerMapping,
          },
        });
        if (values.gerberFileLayerMapping !== null) {
          dispatch(
            updateGerberLayerMapping({
              boardId: boardId,
              gerberFileLayerMapping: values.gerberFileLayerMapping,
            }),
          );
        }
        trackGoogleEvent({ action: UPLOAD_GERBERS_EVENT });
        setLoading(false);
      }
    };

    void fetchAndTrace(
      `${settings.api_url}/boards/${boardId}/gerber-upload`,
      uploadHandler,
      errorHandler,
      {
        method: "POST",
      },
    );
  };
  return {
    onSubmit,
    loading,
    errored,
  };
}
